const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/builds/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import i18n from "@/lib/i18n";
import { buildItemsQueryOptions, buildQueryOptions } from "@/queries/build-details";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/builds/$id")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    await Promise.allSettled([context.queryClient.ensureQueryData(buildQueryOptions(id)), context.queryClient.ensureQueryData(buildItemsQueryOptions(id))]);
    return {
      id,
      dehydratedState: dehydrate(context.queryClient)
    };
  },
  // @ts-expect-error - loader return type
  beforeLoad: async ctx => {
    const subPath = ctx.location.pathname.toString().split(`/${ctx.params.id}/`)[1] as string | undefined;
    if (!subPath) {
      throw redirect({
        to: "/{-$locale}/builds/$id/files",
        params: {
          id: ctx.params.id
        },
        search: {
          view: "changes",
          page: 1
        },
        replace: true,
        resetScroll: true
      });
    }
  },
  head: ctx => {
    const queryClient = getQueryClient();
    if (!ctx.loaderData) return {
      meta: [{
        title: i18n.t("builds.notFound")
      }]
    };
    const build = getFetchedQuery<SingleBuild>(queryClient, ctx.loaderData.dehydratedState, ["build", {
      id: ctx.params.id
    }]);
    const items = getFetchedQuery<BuildItemsResponse>(queryClient, ctx.loaderData.dehydratedState, ["build-items", {
      id: ctx.params.id
    }]);
    if (!build) return {
      meta: [{
        title: i18n.t("builds.notFound")
      }]
    };
    const title = items?.data[0]?.title ?? build.appName;
    return {
      meta: [{
        title: i18n.t("builds.meta.title", {
          title,
          version: build.buildVersion
        })
      }, {
        name: "description",
        content: i18n.t("builds.meta.description", {
          title,
          version: build.buildVersion
        })
      }]
    };
  }
});